module.exports = __webpack_public_path__ + "img/xiz.a5f2f5a0.png";